import { PaymentResult, PaymentResultValues } from '../types'

const PAYMENT_RESULT_QUERY_PARAM = 'payment'

const resultCodeToPaymentResult: Record<string, PaymentResult> = {
  Authorised: PaymentResultValues.OK,
  Pending: PaymentResultValues.PENDING,
  Received: PaymentResultValues.PENDING,
  Refused: PaymentResultValues.DECLINE,
}

const nonTerminalResultCodes = new Set([
  'Authorised',
  'Pending',
  'Received',
  'ChallengeShopper',
  'IdentifyShopper',
  'RedirectShopper',
  'PresentToShopper',
])

const paymentResultsByQueryValue: Record<string, PaymentResult> = {
  ok: PaymentResultValues.OK,
  pending: PaymentResultValues.PENDING,
  decline: PaymentResultValues.DECLINE,
  exception: PaymentResultValues.EXCEPTION,
}

export function parsePaymentResultFromQueryString(search: string): PaymentResult | null {
  const value = new URLSearchParams(search).get(PAYMENT_RESULT_QUERY_PARAM)

  if (!value) {
    return null
  }

  return paymentResultsByQueryValue[value.toLowerCase()] ?? null
}

export function resolvePaymentResultFromResultCode(resultCode?: string): PaymentResult {
  if (!resultCode) {
    return PaymentResultValues.EXCEPTION
  }

  return resultCodeToPaymentResult[resultCode] ?? PaymentResultValues.EXCEPTION
}

export function requiresPaymentMethodReselection(resultCode?: string): boolean {
  return !resultCode || !nonTerminalResultCodes.has(resultCode)
}

export function hidesPaymentOptions(paymentResult: PaymentResult | null): boolean {
  return paymentResult === PaymentResultValues.OK || paymentResult === PaymentResultValues.PENDING
}
